module.exports = __webpack_public_path__ + "static/media/desarrollo5.60a05a35.png";